<template>
  <div class="input-group">
    <note-component :node="node" :rows="6" />
  </div>
</template>

<script>
import NoteComponent from '../../../components/note'

export default {
  props: {
    node: Object
  },
  components: {
    NoteComponent
  }
}
</script>
